import { Avatar, styled } from '@arpeggi/ui'

const Root = styled('div', {
  color: '$black',
  marginBottom: '16px',
  position: 'relative'
})

const TitleText = styled('div', {
  flex: 1,
  fontSize: '$36',
  letterSpacing: '-0.03em',
  fontWeight: '700',
  marginBottom: '8px',
  marginRight: '96px'
})

const ArtistSection = styled('a', {
  display: 'flex'
})

const ArtistAvatar = styled(Avatar, {
  width: '24px',
  maxWidth: '24px'
})

const ArtistText = styled('div', {
  paddingLeft: '8px',
  fontSize: '$16',
  fontWeight: '700'
})

const DateText = styled('div', {
  fontSize: '$16',
  marginLeft: '8px'
})

const Details = styled('div', {
  fontSize: '$14',
  lineHeight: '20px',
  fontWeight: 400,
  marginTop: '12px',
  color: '$blackA600'
})

export const InfoArea = {
  Root,
  TitleText,
  ArtistSection,
  ArtistAvatar,
  ArtistText,
  DateText,
  Details
}
